// @flow

import './main.css'
import 'tachyons'
import 'tachyons-word-break'
import '../../node_modules/font-awesome/css/font-awesome.min.css'
import 'nprogress/nprogress.css'
import 'react-select/dist/react-select.css'
import 'react-image-crop/dist/ReactCrop.css'
import 'react-toggle/style.css'

// Custom tachyons
import './animations.css'
import './border-colors.css'
import './colors.css'
import './heights.css'
import './skins.css'
import './spacing.css'
import './widths.css'



// WEBPACK FOOTER //
// ./src/styles/index.js